const filterActiveEventLocations = (events) => events.filter((event) => event.activeEvent);

export default filterActiveEventLocations;
